import * as Yup from 'yup';

const testLessThanOrEqual = (digit: number) => {
  return (val: any) => val === null || ((val || val === 0) && val.toString().length <= digit)
}

export const createChatInputValidationSchema = (
  needsVehicle: boolean,
  needsNenrei: boolean,
) => {
  let validationSchema = {
    messageType: Yup.number().nullable().oneOf([1, 2, 3], '入力必須です。'),
    message: Yup.string().nullable().max(4000, '4000文字以下で入力してください。'),
    currentContractCarName: Yup.string()
      .nullable()
      .required('入力必須です。')
      .max(100, '100文字以下で入力してください。'),
    currentContractCarRegistrationNumber: Yup.string()
      .nullable()
      .required('入力必須です。')
      .length(4, '4桁で入力してください。'),
    isLongTermContract: Yup.number().oneOf([1, 2], '入力必須です。'),
    addOrMinus: Yup.number().nullable().oneOf([1, 2], '入力必須です。'),
    updatedInsuranceFee: Yup.number()
      .nullable()
      .required('入力必須です。')
      .test(
        'len',
        '9桁以下で入力してください。',
        testLessThanOrEqual(9)
      ),
    updatedMonthlyInsuranceFee: Yup.number()
      .nullable()
      .test(
        'len',
        '9桁以下で入力してください。',
        testLessThanOrEqual(9)
      ),
    aboutUpdatedInsuranceFee: Yup.number().nullable().oneOf([1, 2, 3, 4, 5, 6, 7], '入力必須です。'),
    aboutUpdatedInsuranceFeeDetail: Yup.string()
      .nullable()
      .max(
        1000,
        '1000文字以下で入力してください。'
      ),
    updatedInsuranceFeeOfNextYear: Yup.number()
      .nullable()
      .test(
        'len',
        '9桁以下で入力してください。',
        testLessThanOrEqual(9)
      ),
    paymentMethodOfNextYear: Yup.number().nullable(),
    updatedInsuranceFeeOfThirdYear: Yup.number()
      .nullable()
      .test(
        'len',
        '9桁以下で入力してください。',
        testLessThanOrEqual(9)
      ),
    paymentMethodOfThirdYear: Yup.number().nullable(),
    newCarSpecialContractAddOrMinus: Yup.number().nullable(),
    newCarSpecialContractUpdatedInsuranceFee: Yup.number()
      .nullable()
      .test(
        'len',
        '9桁以下で入力してください。',
        testLessThanOrEqual(9)
      ),
    newCarSpecialContractUpdatedMonthlyInsuranceFee: Yup.number()
      .nullable()
      .test(
        'len',
        '9桁以下で入力してください。',
        testLessThanOrEqual(9)
      ),
    newCarSpecialContractUpdatedInsuranceFeeOfNextYear: Yup.number()
      .nullable()
      .test(
        'len',
        '9桁以下で入力してください。',
        testLessThanOrEqual(9)
      ),
    newCarSpecialContractPaymentMethodOfNextYear: Yup.number().nullable(),
    newCarSpecialContractUpdatedInsuranceFeeOfThirdYear: Yup.number()
      .nullable()
      .test(
        'len',
        '9桁以下で入力してください。',
        testLessThanOrEqual(9)
      ),
    newCarSpecialContractPaymentMethodOfThirdYear: Yup.number().nullable(),
    remarks: Yup.string()
      .nullable()
      .max(4000, '4000文字以下で入力してください。'),
  }

  if (needsVehicle) {
    validationSchema = {
      ...validationSchema,
      ...{
        updatedContractCarName: Yup.string()
          .nullable()
          .required('入力必須です。')
          .max(100, '100文字以下で入力してください。'),
        yearAndMonthOfFirstRegistration: Yup.string()
          .nullable()
          .required('入力必須です。')
          .max(100, '100文字以下で入力してください。'),
        carModel: Yup.string()
          .nullable()
          .required('入力必須です。')
          .max(100, '100文字以下で入力してください。'),
        chassisNumber: Yup.string()
          .nullable()
          .required('入力必須です。')
          .max(100, '100文字以下で入力してください。'),
        carType: Yup.string().nullable().max(100, '100文字以下で入力してください。'),
        baseLocationForUse: Yup.string().nullable().max(100, '100文字以下で入力してください。'),
        carOwner: Yup.string().nullable().max(100, '100文字以下で入力してください。'),
        carOwnerKana: Yup.string().nullable().max(100, '100文字以下で入力してください。'),
        updatedContractCarRegistrationNumber: Yup.string()
          .nullable()
          .required('入力必須です。')
          .max(100, '100文字以下で入力してください'),
        updatedCarInsuranceFee: Yup.number()
          .nullable()
          .test(
            'len',
            '9桁以下で入力してください。',
            testLessThanOrEqual(9)
          )
          .when('carInsuranceType', {
            is: (carInsuranceType) =>
              carInsuranceType === 1 || carInsuranceType === 2,
            then: Yup.number().required('入力必須です。'),
          }),
        // 車両保険タイプが、1:一般条件　or　2:車対車限定危険特約　の時、「変更後の車両保険金額」「自己負担額」が必須入力になる
        outOfPocketFeeFirstTime: Yup.number()
          .test(
            'len',
            '9桁以下で入力してください。',
            testLessThanOrEqual(9)
          )
          .nullable()
          .when('carInsuranceType', {
            is: (carInsuranceType) =>
              carInsuranceType === 1 || carInsuranceType === 2,
            then: Yup.number().required('入力必須です。'),
          }),
        outOfPocketFeeAfterSecondTime: Yup.number()
          .nullable()
          .test(
            'len',
            '9桁以下で入力してください。',
            testLessThanOrEqual(9)
          )
          .when('carInsuranceType', {
            is: (carInsuranceType) =>
              carInsuranceType === 1 || carInsuranceType === 2,
            then: Yup.number().required('入力必須です。'),
          }),
        carInsuranceFeeNextYear: Yup.number()
          .nullable()
          .test(
            'len',
            '9桁以下で入力してください。',
            testLessThanOrEqual(9)
          ),
        carInsuranceFeeThirdYear: Yup.number()
          .nullable()
          .test(
            'len',
            '9桁以下で入力してください。',
            testLessThanOrEqual(9)
          ),
      }
    }
  }

  if (needsNenrei) {
    validationSchema = {
      ...validationSchema,
      ...{
        isPersonalAndInsuranceStartTerm: Yup.number().nullable().oneOf(
          [1, 2, 3],
          '入力必須です。'
        ),
        updatedDriverSpecialContract: Yup.number().nullable().oneOf(
          [1, 2, 3, 4],
          '入力必須です。'
        ),
        updatedDriverAgeConditionSpecialContract: Yup.number().nullable().oneOf(
          [1, 2, 3, 4],
          '入力必須です。'
        ),
      }
    }
  }

  return Yup.object(validationSchema)
}
